import type { DisclosureDetail, DisclosureSettingChange } from "@/lib/ai-disclosure/report"

export const disclosureCsvHeader = "row_type,channel,conversation_id,notice_kind,first_activity_utc,first_outcome,latest_outcome,event_channel,event_time_utc,event_status,language,disclosure_text,failure_reason,ai_setting_at_activity,setting_enabled,previous_setting_enabled,setting_source,changed_by_user_id,recorded_at_utc,accepted_confirmation"

export function disclosureDetailsCsv(details: DisclosureDetail[], changes: DisclosureSettingChange[] = []): string[] {
  const rows = details.flatMap(row => {
    const events = row.events.length ? row.events : [null]
    return events.map(event => ({ at: event?.occurredAt ?? row.firstActivityAt, values: [
      event ? "disclosure_event" : "missing_evidence",
      row.channel, row.conversationRef, row.noticeKind, row.firstActivityAt, row.status, row.latestStatus,
      event?.channel ?? "", event?.occurredAt ?? "", event?.status ?? "missing", event?.language ?? "",
      event?.noticeText ?? "", event?.failureReason ?? "",
      settingValue(row.enabledAtActivity), "", "", "", "", "", "",
    ] }))
  })
  rows.push(...changes.map(change => ({ at: change.effectiveAt, values: [
    change.source === "initial_state" ? "initial_state" : "setting_change",
    "organization", "", "ai_setting", "", "", "", "organization", change.effectiveAt,
    change.enabled ? "enabled" : "disabled", "", change.source === "initial_state" ? "Initial setting state" : "Organization AI disclosure setting changed",
    "", "", settingValue(change.enabled), settingValue(change.previousEnabled), change.source,
    change.actorUserId ?? "", change.recordedAt, change.acceptedConfirmationText ?? "",
  ] })))
  return rows.sort((a, b) => a.at.localeCompare(b.at) ||
    Number(isSettingRow(b.values[0])) - Number(isSettingRow(a.values[0])))
    .map(row => row.values.map(csvCell).join(","))
}

function isSettingRow(type: string): boolean {
  return type === "initial_state" || type === "setting_change"
}

function settingValue(enabled: boolean | null | undefined): string {
  if (enabled == null) return "unknown"
  return enabled ? "enabled" : "disabled"
}

function csvCell(value: string): string {
  const safe = /^[\s]*[=+@-]/.test(value) ? `'${value}` : value
  return `"${safe.replaceAll('"', '""')}"`
}
